/*
  Location: /assets/ls-modal.js
  Purpose: Handles the click-to-expand image modal on product pages.
  UPDATED: Now uses JavaScript to force the styles for maximum compatibility.
*/
document.addEventListener('DOMContentLoaded', function() {
  // Use a more direct selector to find the gallery.
  const gallery = document.querySelector('.product-gallery-bespoke');

  if (!gallery) {
    // If the gallery isn't found, do nothing.
    return;
  }

  // Use event delegation to handle clicks on images
  gallery.addEventListener('click', function(event) {
    // Make sure the clicked element is an image
    if (event.target.tagName === 'IMG') {
      const clickedImage = event.target;

      // --- Create Modal Elements ---
      const overlay = document.createElement('div');
      const content = document.createElement('div');
      const closeButton = document.createElement('span');
      const largeImage = document.createElement('img');

      // --- Force Styles with JavaScript ---
      // This bypasses any conflicting theme CSS.
      Object.assign(overlay.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '99999',
        cursor: 'zoom-out',
        opacity: '0',
        transition: 'opacity 0.3s ease'
      });
      
      Object.assign(content.style, {
        maxWidth: '90%',
        maxHeight: '90%'
      });

      Object.assign(largeImage.style, {
        width: 'auto',
        height: 'auto',
        maxWidth: '100%',
        maxHeight: '100%',
        display: 'block',
        borderRadius: '5px'
      });
      
      Object.assign(closeButton.style, {
        position: 'absolute',
        top: '20px',
        right: '20px',
        color: 'white',
        fontSize: '3rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        lineHeight: '1'
      });
      closeButton.innerHTML = '&times;';
      
      // Get the original image URL and request a larger version from Shopify
      const largeImageUrl = clickedImage.src.replace(/_(\d+)x\./, '_1600x.');
      largeImage.src = largeImageUrl;

      // Assemble the modal
      content.appendChild(largeImage);
      overlay.appendChild(content);
      overlay.appendChild(closeButton);
      document.body.appendChild(overlay);

      // Prevent body from scrolling
      document.body.style.overflow = 'hidden';
      
      // A small delay ensures the CSS transition is applied correctly
      setTimeout(() => {
        overlay.style.opacity = '1';
      }, 10);

      // Function to close the modal
      const closeModal = () => {
        overlay.style.opacity = '0';
        setTimeout(() => {
          if (document.body.contains(overlay)) {
            document.body.removeChild(overlay);
          }
          document.body.style.overflow = '';
        }, 300); // Wait for fade-out transition
      };

      // Close the modal if the overlay or close button is clicked
      overlay.addEventListener('click', closeModal);
      closeButton.addEventListener('click', closeModal);
    }
  });
});
